module.exports = __webpack_public_path__ + "img/image8.a4e4434c.png";